import { useQueryClient } from '@tanstack/react-query';
import { useSignalR } from 'hooks/useSiglanR';
import { useSignalREvent } from 'hooks/useSignalREvent';
import { useCallback } from 'react';
import { INotificationEvents } from './types';

export const refreshNotificationsQueries = async (
  queryClient: ReturnType<typeof useQueryClient>,
) => {
  await queryClient.invalidateQueries({
    queryKey: ['get-unread-notification '],
  });
  await queryClient.invalidateQueries({
    queryKey: ['notifications'],
  });
  await queryClient.invalidateQueries({
    queryKey: ['notifications-archive'],
  });

  await queryClient.refetchQueries({
    queryKey: ['get-unread-notification '],
    type: 'active',
  });
  await queryClient.refetchQueries({
    queryKey: ['notifications'],
    type: 'active',
  });
  await queryClient.refetchQueries({
    queryKey: ['notifications-archive'],
    type: 'active',
  });
};

export const useNotificationsConnection = (enabled = false) => {
  const queryClient = useQueryClient();

  const { connection } = useSignalR('notifications', {
    disabled: !enabled,
  });

  const onReceiveNotification = useCallback(async () => {
    console.log('[SignalR notifications] ReceiveNotification');
    await refreshNotificationsQueries(queryClient);
  }, [queryClient]);

  const onNotificationRead = useCallback(async () => {
    console.log('[SignalR notifications] NotificationRead');
    await refreshNotificationsQueries(queryClient);
  }, [queryClient]);

  const onAllNotificationsRead = useCallback(async () => {
    console.log('[SignalR notifications] AllNotificationsRead');
    await refreshNotificationsQueries(queryClient);
  }, [queryClient]);

  useSignalREvent<INotificationEvents, 'ReceiveNotification'>(
    connection,
    'ReceiveNotification',
    onReceiveNotification,
  );

  useSignalREvent<INotificationEvents, 'NotificationRead'>(
    connection,
    'NotificationRead',
    onNotificationRead,
  );

  useSignalREvent<INotificationEvents, 'AllNotificationsRead'>(
    connection,
    'AllNotificationsRead',
    onAllNotificationsRead,
  );

  if (!enabled) return null;

  return connection;
};
